export default function FeaturingApp(props) {
  const {title,desc,image} = props;
  return (
    <div className="col-md-6 col-lg-3 mb-3">
      <div className="cardItem">
        <div className="imageCard">
          <img src={image} className="img-fluid" alt="" />
        </div>
        <div className="itemInfo">
          <span className="itemDesc"> {title} </span>
          <div className="itemDetail">
            {desc}
          </div>
        </div>
      </div>
    </div>
  )
}
